import { type SetAppDataAction, SET_APP_DATA } from '../../../actions/app/index.tsx';
import {
	ISSUE_PARENTS_CREATE_SET,
	type IssueParentsCreateSetAction,
} from '../../../actions/issue-parents/create/index.tsx';
import {
	LOAD_ISSUE_PARENTS_SUCCESS,
	type LoadIssueParentsSuccessAction,
} from '../../../actions/issue-parents/load/index.tsx';
import type { IssueParentsOrderState } from './types.tsx';

type Action = SetAppDataAction | IssueParentsCreateSetAction | LoadIssueParentsSuccessAction;

const defaultState: IssueParentsOrderState = [];

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	state: IssueParentsOrderState = defaultState,
	action: Action,
): IssueParentsOrderState => {
	switch (action.type) {
		case SET_APP_DATA: {
			const {
				payload: {
					entities: { issueParentsOrder },
				},
			} = action;
			return issueParentsOrder || state;
		}

		case ISSUE_PARENTS_CREATE_SET: {
			const issueParentIds = action.payload.issueParents.map((issueParent) => issueParent.id);
			return [...state, ...issueParentIds];
		}

		case LOAD_ISSUE_PARENTS_SUCCESS:
			return action.payload.issueParents.map((issueParent) => issueParent.id);

		default:
			return state;
	}
};
